import React, { useState } from 'react';
import { Link, useLocation, Outlet } from 'react-router-dom';
import { Layout, Menu, Typography } from 'antd';
import { DashboardOutlined, TeamOutlined, MailOutlined, FileTextOutlined, FilterOutlined, SyncOutlined, MenuFoldOutlined, MenuUnfoldOutlined, RobotOutlined } from '@ant-design/icons';

const { Header, Sider, Content } = Layout;
const { Title } = Typography;

const menuItems = [
  { key: '/dashboard', icon: <DashboardOutlined />, label: <Link to="/dashboard">대시보드</Link> },
  { key: '/contacts', icon: <TeamOutlined />, label: <Link to="/contacts">연락처</Link> },
  { key: '/campaigns', icon: <MailOutlined />, label: <Link to="/campaigns">캠페인</Link> },
  { key: '/templates', icon: <FileTextOutlined />, label: <Link to="/templates">템플릿</Link> },
  { key: '/segments', icon: <FilterOutlined />, label: <Link to="/segments">세그먼트</Link> },
  { key: '/sync', icon: <SyncOutlined />, label: <Link to="/sync">동기화 설정</Link> },
  { key: '/auto-campaign', icon: <RobotOutlined />, label: <Link to="/auto-campaign">AI 자동 캠페인</Link> },
];

const MainLayout = () => {
  const [collapsed, setCollapsed] = useState(false);
  const location = useLocation();

  return (
    <Layout style={{ minHeight: '100vh' }}>
      <Sider trigger={null} collapsible collapsed={collapsed} style={{ overflow: 'auto', height: '100vh', position: 'fixed', left: 0 }}>
        <div style={{ height: 64, display: 'flex', alignItems: 'center', justifyContent: 'center', borderBottom: '1px solid rgba(255,255,255,0.1)' }}>
          <Title level={4} style={{ color: 'white', margin: 0 }}>{collapsed ? 'MH' : 'Marketing Hub'}</Title>
        </div>
        <Menu theme="dark" mode="inline" selectedKeys={[location.pathname]} items={menuItems} />
      </Sider>
      <Layout style={{ marginLeft: collapsed ? 80 : 200, transition: 'margin-left 0.2s' }}>
        <Header style={{ padding: '0 24px', background: '#fff', display: 'flex', alignItems: 'center', boxShadow: '0 1px 4px rgba(0,0,0,0.08)' }}>
          {React.createElement(collapsed ? MenuUnfoldOutlined : MenuFoldOutlined, { onClick: () => setCollapsed(!collapsed), style: { fontSize: 18, cursor: 'pointer' } })}
        </Header>
        <Content className="site-layout-content">
          <Outlet />
        </Content>
      </Layout>
    </Layout>
  );
};

export default MainLayout;
